import { createContext } from 'react';

export type Toast = {
  message: string;
  type: 'success' | 'error' | 'warning';
  id: string;
  stick?: boolean;
  clearToasts?: boolean;
};

export type NewToast = Omit<Toast, 'id'>;

export interface ToastContext {
  toasts: Toast[];
  addToast: (newToast: NewToast) => void;
}
const defaultValue: ToastContext = {
  toasts: [],
  addToast: () => {},
};

export const ToastContext = createContext<ToastContext>(defaultValue);
